import React from 'react';
import i8 from '../../assets/i8.gif';
import i9 from '../../assets/i9.gif';
import i10 from '../../assets/i10.gif';


const B5 = () => {
  return (
    <div className='page1'>
    <div className='overall'>
      <h2 className='heading'>தாய்ப்பால் ஊட்டுதல்</h2>
      <h3 className='subheading'>தாய்ப்பால் ஊட்டுவதற்கான அடிப்படை முறைகள்</h3>

    </div>
      <div className='answer'>
     <h4  style={{ color: '#BB0297' }}>குழந்தை ஏப்பம் விடுதல்:-</h4> 

<p>உங்கள் குழந்தை ஏப்பம் விடுதல் குழந்தையின் உணவளிக்கும் வழக்கத்தின் முக்கிய பகுதியாகும் உங்கள் குழந்தை விழுங்கும் போது, காற்று குமிழ்கள் வயிற்றில் சிக்கி அசௌகரியத்தை ஏற்படுத்தும். பர்பிங் உங்கள் குழந்தைக்கு அந்த வாயுவை அகற்ற அனுமதிக்கிறது.</p>
<br /><br />

<h4>1. நிமிர்ந்து உட்கார்ந்து, உங்கள் குழந்தையை உங்கள் மார்பில் பிடிக்கவும்.</h4>
<img src={i8}  className='image' alt=""/>

நீங்கள் குழந்தையை ஒரு கையால் தாங்கும் போது உங்கள் குழந்தையின் கன்னம் உங்கள் தோளில் இருக்க வேண்டும். மறுபுறம், உங்கள் குழந்தையின் முதுகில் ஏப்பம் வரும் வரை மெதுவாகத் தட்டவும்.

<br /><br />

<h4>2. உங்கள் குழந்தையை உங்கள் மடியில் அல்லது உங்கள் முழங்காலுக்கு குறுக்கே அமர்ந்து பிடித்துக் கொள்ளுங்கள்.</h4>
<img src={i9}  className='image' alt=""/>

உங்கள் குழந்தையின் கன்னத்தை உங்கள் உள்ளங்கையில் வைத்து ஒரு கையால் உங்கள் குழந்தையின் மார்பு மற்றும் தலையை ஆதரிக்கவும். குழந்தையின் கன்னத்தை பிடிக்க
கவனமாக இருங்கள், தொண்டை அல்ல, உங்கள் குழந்தையின் முதுகில் தட்டுவதற்கு மற்றொரு கையைப் பயன்படுத்தவும்.

<br /><br />

<h4>3. உங்கள் குழந்தையை உங்கள் மடியில் அவரது வயிற்றில் படுக்க வைக்கவும்.</h4>
<img src={i10}  className='image' alt=""/>

உங்கள் குழந்தையின் தலையை ஆதரிக்கவும், அது அவர்களின் மார்பை விட உயரமாக இருப்பதை உறுதிப்படுத்தவும். உங்கள் குழந்தையின் முதுகில் மெதுவாக தட்டவும்.
    </div>
    </div>      
     
   
  );
};

export default B5
